import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-144">
      <div className="max-w-4xl mx-auto text-center" data-id="element-145">
        {/* Logo */}
        <div className="text-[#00E676] text-3xl font-black tracking-widest mb-8" data-id="element-146">
          🧬 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-147">
          El próximo domingo podés seguir buscando material en Google.
        </h2>
        <p className="text-[#00E676] text-2xl sm:text-3xl font-black mb-10" data-id="element-148">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a0d] border border-[#00E676]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-149">
          <div className="p-4 bg-[#000d08] border-b border-[#00E676]/30 text-center font-bold text-white" data-id="element-150">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-151">
            <div className="p-4 text-gray-400 text-sm" data-id="element-152">
              3 horas de planificación por semana × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00E676]/5 sm:border-l border-gray-800" data-id="element-153">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-154">
            <div className="p-4 text-gray-400 text-sm" data-id="element-155">
              Evaluaciones sin solucionario × 30 alumnos × 3 trimestres
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00E676]/5 sm:border-l border-gray-800" data-id="element-156">
              Sábados de corrección sin criterios claros
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-157">
            <div className="p-4 text-gray-400 text-sm" data-id="element-158">
              Material adaptado para PPI inventado en el momento
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00E676]/5 sm:border-l border-gray-800" data-id="element-159">
              Riesgo legal + desgaste docente
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-160">
            <div className="p-4 text-gray-400 text-sm" data-id="element-161">
              Clases improvisadas que no enganchan
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00E676]/5 sm:border-l border-gray-800" data-id="element-162">
              Alumnos que se pierden y no vuelven
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-163">
          <p className="text-white font-bold mb-4" data-id="element-164">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-165" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-166">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-167">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-168">
          <div className="bg-[#0a0a0a] border border-[#00E676]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-169">
            <div className="text-2xl mb-2" data-id="element-170">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-171">MEGAPACK BIOLOGÍA</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-172">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-173">
              <p className="text-[#00E676] text-2xl font-black mb-4" data-id="element-174">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48097188249856:1" className="btn-green-pulse block bg-[#00E676] text-black font-black py-4 rounded-lg hover:bg-green-400 transition-colors text-sm" data-id="element-175">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d08] border-2 border-[#00E676] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,230,118,0.2)] flex flex-col" data-id="element-176">
            <div className="text-2xl mb-2" data-id="element-177">🏆</div>
            <h3 className="text-[#00E676] font-black mb-1" data-id="element-178">
              MEGAPACK + ADAPTACIONES ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-179">
              6 Tomos + 6 Bonos + Bio-Inclusión Pack™ (adaptaciones al aula)
            </p>
            <div className="mt-auto" data-id="element-180">
              <p className="text-[#00E676] text-3xl font-black mb-4" data-id="element-181">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48118231466240:1" className="btn-green-pulse block bg-[#00E676] text-black font-black py-4 rounded-lg hover:bg-green-400 transition-colors text-sm" data-id="element-182">
                → QUIERO EL MEGAPACK + ADAPTACIONES
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-183">
          <span data-id="element-184">🔒 Pago 100% seguro</span>
          <span data-id="element-185">⚡ Acceso en 5 minutos</span>
          <span data-id="element-186">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-187">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}